// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.file-data-asset-setup {
  width: 100%;
  padding-top: 1.25rem;
  padding-bottom: 2.5rem;
}

.setup-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.setup-page-header h1 {
  margin: 0 0 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.55rem, 2vw, 1.9rem);
  font-weight: 700;
  letter-spacing: -0.025em;
}

.eyebrow {
  margin: 0 0 0.35rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.page-description {
  max-width: 760px;
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.93rem;
}

.source-type-chip,
.format-pill,
.count-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  flex-shrink: 0;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: #fff;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.48rem 0.8rem;
}

.source-type-chip i {
  color: var(--ca-primary, #0e2e80);
}

.setup-card {
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 16px;
  background: var(--ca-surface, #fff);
  box-shadow: 0 4px 16px rgba(7, 17, 46, 0.055);
}

.setup-stepper {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: #fbfcff;
}

.stepper-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  padding-right: 1rem;
}

.stepper-item:not(:last-child)::after {
  position: absolute;
  top: 1rem;
  right: 0.85rem;
  left: 2.7rem;
  height: 1px;
  background: var(--ca-border, #dfe4ec);
  content: "";
  transform: translateX(1rem);
}

.stepper-marker {
  z-index: 1;
  display: grid;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 50%;
  background: #fff;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.82rem;
  font-weight: 700;
}

.stepper-item.active .stepper-marker,
.stepper-item.completed .stepper-marker {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.stepper-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.1rem;
}

.stepper-title {
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
  font-weight: 700;
}

.stepper-description {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
}

.stepper-item:not(.active):not(.completed) .stepper-title {
  color: var(--ca-text-muted, #8c96a8);
}

.wizard-panel {
  padding: clamp(1.25rem, 3vw, 2rem);
}

.panel-heading {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  margin-bottom: 1.5rem;
}

.panel-heading-icon {
  display: grid;
  width: 2.75rem;
  height: 2.75rem;
  flex: 0 0 2.75rem;
  place-items: center;
  border-radius: 12px;
  background: #edf3ff;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.2rem;
}

.panel-heading-icon.success-icon {
  background: #eaf7f0;
  color: #198754;
}

.panel-heading h2 {
  margin: 0 0 0.3rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.18rem;
  font-weight: 700;
}

.panel-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.88rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem 1.5rem;
}

.field-group {
  min-width: 0;
}

.field-full {
  grid-column: 1/-1;
}

.form-label {
  display: inline-block;
  margin-bottom: 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
  font-weight: 650;
}

.required-mark {
  color: #dc3545;
}

.form-control,
.form-select {
  min-height: 2.75rem;
  border-color: var(--ca-input-border, #dfe4ec);
  border-radius: 8px;
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
  box-shadow: none;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.13);
}

.field-hint,
.field-error {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.76rem;
}

.field-hint {
  color: var(--ca-text-muted, #8c96a8);
}

.field-error {
  color: #dc3545;
}

.identity-note,
.summary-note {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-top: 1.5rem;
  padding: 0.9rem 1rem;
  border: 1px solid #dce6ff;
  border-radius: 10px;
  background: #f5f8ff;
  color: #435574;
  font-size: 0.82rem;
}

.identity-note i,
.summary-note i {
  margin-top: 0.1rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 1rem;
}

.wizard-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 2rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.wizard-actions-between {
  justify-content: space-between;
}

.action-group {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.55rem;
  border-radius: 8px;
  font-size: 0.84rem;
  font-weight: 650;
  padding: 0.55rem 1rem;
}

.btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
}

.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}

.btn-outline-primary {
  border-color: var(--ca-primary, #0e2e80);
  color: var(--ca-primary, #0e2e80);
}

.btn-outline-primary:hover:not(:disabled) {
  background: #edf3ff;
  color: var(--ca-primary, #0e2e80);
}

.choice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.choice-card {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  width: 100%;
  min-width: 0;
  padding: 1.1rem;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 12px;
  background: #fff;
  color: inherit;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.choice-card:hover:not(:disabled) {
  border-color: #9db7f6;
  background: #fbfcff;
}

.choice-card.selected {
  border-color: var(--ca-primary, #0e2e80);
  background: #f5f8ff;
  box-shadow: inset 0 0 0 1px var(--ca-primary, #0e2e80);
}

.choice-card:disabled {
  cursor: not-allowed;
  opacity: 0.8;
}

.choice-icon {
  display: grid;
  width: 2.55rem;
  height: 2.55rem;
  flex: 0 0 2.55rem;
  place-items: center;
  border-radius: 10px;
  background: #edf3ff;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.12rem;
}

.choice-icon.secondary {
  background: #f1f3f6;
  color: #667085;
}

.choice-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.choice-content strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
}

.choice-content span {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
  line-height: 1.5;
}

.selection-indicator {
  margin-top: 0.15rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 1.05rem;
}

.choice-card.selected .selection-indicator {
  color: var(--ca-primary, #0e2e80);
}

.file-import-panel {
  margin-top: 1.5rem;
  padding: 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 12px;
  background: #fcfdff;
}

.file-panel-heading,
.table-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.file-panel-heading h3,
.table-heading h3 {
  margin: 0 0 0.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.98rem;
  font-weight: 700;
}

.file-panel-heading p,
.table-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
}

.format-pill {
  border-color: #dce6ff;
  background: #f5f8ff;
  color: var(--ca-primary, #0e2e80);
}

.file-dropzone {
  display: flex;
  min-height: 210px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 1.5rem;
  border: 1.5px dashed #b8c5dd;
  border-radius: 12px;
  background: #fff;
  text-align: center;
}

.file-dropzone.has-file {
  border-style: solid;
  border-color: #b7e3ca;
  background: #fbfefc;
}

.dropzone-icon {
  display: grid;
  width: 3.1rem;
  height: 3.1rem;
  margin-bottom: 0.25rem;
  place-items: center;
  border-radius: 50%;
  background: #edf3ff;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.4rem;
}

.file-selected-icon {
  background: #eaf7f0;
  color: #198754;
}

.file-dropzone > strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.91rem;
}

.file-dropzone > span:not(.dropzone-icon) {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.8rem;
}

.selected-file-name {
  max-width: 100%;
  overflow-wrap: anywhere;
}

.browse-button {
  margin-top: 0.55rem;
  cursor: pointer;
}

.text-button {
  border: 0;
  background: transparent;
  color: #b42332;
  font-size: 0.8rem;
  font-weight: 650;
  text-decoration: underline;
}

.file-error {
  margin-top: 0.65rem;
}

.import-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
}

.import-context {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  max-width: 620px;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
}

.import-context i {
  margin-top: 0.05rem;
  color: var(--ca-primary, #0e2e80);
}

.import-result {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  margin-top: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 9px;
  background: #f8faff;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.import-result-success {
  border-color: #b7e3ca;
  background: #f1fbf5;
  color: #17653d;
}

.import-result-error {
  border-color: #f3b9c0;
  background: #fff5f6;
  color: #a51f2d;
}

.imported-assets-section {
  margin-top: 1.5rem;
}

.table-heading {
  align-items: center;
}

.count-pill {
  border-color: #dce6ff;
  background: #f5f8ff;
  color: var(--ca-primary, #0e2e80);
}

.assets-table-wrapper {
  overflow: auto;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 10px;
}

.assets-table {
  min-width: 780px;
  margin: 0;
  font-size: 0.8rem;
}

.assets-table thead th {
  padding: 0.85rem 1rem;
  border-bottom-color: var(--ca-border, #dfe4ec);
  background: #f5f7fb;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.72rem;
  font-weight: 750;
  letter-spacing: 0.025em;
  white-space: nowrap;
}

.assets-table tbody td {
  padding: 0.85rem 1rem;
  border-bottom-color: var(--ca-border-light, #e9edf3);
  color: var(--ca-text-secondary, #4b5870);
  vertical-align: middle;
}

.assets-table tbody tr:last-child td {
  border-bottom: 0;
}

.assets-table tbody tr:hover {
  background: #fbfcff;
}

.assets-table td strong {
  display: block;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}

.asset-description {
  display: block;
  max-width: 260px;
  margin-top: 0.2rem;
  overflow: hidden;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: #f1f3f6;
  color: #667085;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.25rem 0.55rem;
  text-transform: capitalize;
}

.status-pill.status-active {
  background: #eaf7f0;
  color: #198754;
}

.empty-assets-state {
  display: flex;
  min-height: 150px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  border: 1px dashed var(--ca-border, #dfe4ec);
  border-radius: 10px;
  color: var(--ca-text-muted, #8c96a8);
  text-align: center;
}

.empty-assets-state i {
  color: var(--ca-primary, #0e2e80);
  font-size: 1.5rem;
}

.empty-assets-state strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.88rem;
}

.empty-assets-state span {
  font-size: 0.78rem;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.summary-item {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 10px;
  background: #fff;
}

.summary-item-full {
  grid-column: 1/-1;
}

.summary-label {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.74rem;
  font-weight: 650;
}

.summary-item strong {
  overflow-wrap: anywhere;
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
  font-weight: 700;
}

.summary-item .summary-success {
  color: #198754;
}

.summary-long-value {
  font-size: 0.8rem !important;
}

.summary-note code {
  border-radius: 4px;
  background: #e8eeff;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.8rem;
  padding: 0.12rem 0.28rem;
}

.update-panel {
  max-width: 960px;
  margin: 0 auto;
}

.section-divider-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 700;
}

.section-divider-label::after {
  flex: 1;
  height: 1px;
  background: var(--ca-border-light, #e9edf3);
  content: "";
}

.readonly-value {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-height: 2.75rem;
  padding: 0.65rem 0.8rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 8px;
  background: var(--ca-surface-muted, #f7f9fc);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.readonly-value i {
  color: var(--ca-primary, #0e2e80);
  font-size: 1rem;
}

.update-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 220px;
  padding: 2rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.update-load-error {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.85rem;
  padding: 1.5rem;
  color: var(--ca-text-secondary, #4b5870);
}

.update-load-error > i {
  color: #dc3545;
  font-size: 1.2rem;
}

.update-load-error > span {
  flex: 1 1 220px;
}

@media (max-width: 640px) {
  .update-panel {
    padding: 1rem;
  }
  .update-panel .form-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .update-panel .field-full {
    grid-column: auto;
  }
  .update-panel .wizard-actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }
  .update-panel .wizard-actions .btn {
    width: 100%;
  }
}
@media (max-width: 850px) {
  .setup-page-header {
    flex-direction: column;
  }
  .setup-stepper {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .stepper-item:not(:last-child)::after {
    display: none;
  }
  .choice-grid {
    grid-template-columns: 1fr;
  }
  .stepper-description {
    display: none;
  }
}
@media (max-width: 600px) {
  .file-setup-breadcrumb {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .file-data-asset-setup {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .form-grid,
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .field-full,
  .summary-item-full {
    grid-column: auto;
  }
  .wizard-panel {
    padding: 1rem;
  }
  .import-actions,
  .wizard-actions-between {
    align-items: stretch;
    flex-direction: column;
  }
  .action-group {
    justify-content: flex-end;
  }
  .wizard-actions > .btn,
  .action-group .btn {
    flex: 1 1 auto;
  }
  .file-panel-heading,
  .table-heading {
    align-items: flex-start;
  }
}
/* Keeps Purview qualified names readable in the staged data-asset preview. */
.qualified-name {
  display: inline-block;
  max-width: 22rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

@media (max-width: 767.98px) {
  .qualified-name {
    max-width: 12rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/data-asset-capture/data-asset-capture-file-create-or-update/data-asset-capture-file-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EAEE,cAAA;AAAF;;AAKA;EACE,kBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAFF;AAGE;EACE,sCAAA;EACA,0BAAA;AADJ;AAGE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AADJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EACE,wCAAA;EACA,gBAAA;AADF;;AAGA;EACE,kBAAA;AAAF;;AAKA;EAEE,WAAA;EAEA,oBAAA;EAEA,sBAAA;AALF;;AAWA;EAEE,aAAA;EAEA,uBAAA;EAEA,8BAAA;EAEA,WAAA;EAEA,qBAAA;AAbF;;AAmBA;EAEE,mBAAA;EAEA,sCAAA;EAEA,sCAAA;EAEA,gBAAA;EAEA,wBAAA;AArBF;;AA2BA;EAEE,mBAAA;EAEA,iCAAA;EAEA,iBAAA;EAEA,gBAAA;EAEA,sBAAA;AA7BF;;AAmCA;EAEE,gBAAA;EAEA,SAAA;EAEA,wCAAA;EAEA,kBAAA;AApCF;;AA0CA;;;EAME,oBAAA;EAEA,mBAAA;EAEA,YAAA;EAEA,cAAA;EAEA,iDAAA;EAEA,oBAAA;EAEA,gBAAA;EAEA,wCAAA;EAEA,kBAAA;EAEA,gBAAA;EAEA,uBAAA;AApDF;;AA0DA;EAEE,iCAAA;AAxDF;;AA8DA;EAEE,gBAAA;EAEA,iDAAA;EAEA,mBAAA;EAEA,mCAAA;EAEA,6CAAA;AAhEF;;AAsEA;EAEE,aAAA;EAEA,gDAAA;EAEA,MAAA;EAEA,uBAAA;EAEA,wDAAA;EAEA,mBAAA;AAzEF;;AA+EA;EAEE,kBAAA;EAEA,aAAA;EAEA,mBAAA;EAEA,YAAA;EAEA,YAAA;EAEA,mBAAA;AAlFF;;AAwFA;EAEE,kBAAA;EAEA,SAAA;EAEA,cAAA;EAEA,YAAA;EAEA,WAAA;EAEA,qCAAA;EAEA,WAAA;EAEA,2BAAA;AA7FF;;AAmGA;EAEE,UAAA;EAEA,aAAA;EAEA,WAAA;EAEA,YAAA;EAEA,cAAA;EAEA,mBAAA;EAEA,2CAAA;EAEA,kBAAA;EAEA,gBAAA;EAEA,oCAAA;EAEA,kBAAA;EAEA,gBAAA;AA5GF;;AAkHA;;EAIE,wCAAA;EAEA,sCAAA;EAEA,WAAA;AAnHF;;AAyHA;EAEE,aAAA;EAEA,YAAA;EAEA,sBAAA;EAEA,WAAA;AA1HF;;AAgIA;EAEE,sCAAA;EAEA,kBAAA;EAEA,gBAAA;AAhIF;;AAsIA;EAEE,oCAAA;EAEA,kBAAA;AArIF;;AA2IA;EAEE,oCAAA;AAzIF;;AA+IA;EAEE,kCAAA;AA7IF;;AAmJA;EAEE,aAAA;EAEA,uBAAA;EAEA,WAAA;EAEA,qBAAA;AApJF;;AA0JA;EAEE,aAAA;EAEA,cAAA;EAEA,eAAA;EAEA,iBAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,iCAAA;EAEA,iBAAA;AAhKF;;AAsKA;EAEE,mBAAA;EAEA,cAAA;AArKF;;AA2KA;EAEE,kBAAA;EAEA,sCAAA;EAEA,kBAAA;EAEA,gBAAA;AA5KF;;AAkLA;EAEE,SAAA;EAEA,wCAAA;EAEA,kBAAA;AAlLF;;AAwLA;EAEE,aAAA;EAEA,gDAAA;EAEA,mBAAA;AAxLF;;AA8LA;EAEE,YAAA;AA5LF;;AAkMA;EAEE,iBAAA;AAhMF;;AAsMA;EAEE,qBAAA;EAEA,sBAAA;EAEA,sCAAA;EAEA,kBAAA;EAEA,gBAAA;AAxMF;;AA8MA;EAEE,cAAA;AA5MF;;AAkNA;;EAIE,mBAAA;EAEA,6CAAA;EAEA,kBAAA;EAEA,sCAAA;EAEA,iBAAA;EAEA,gBAAA;AAtNF;;AA4NA;;EAIE,4CAAA;EAEA,gDAAA;AA5NF;;AAkOA;;EAIE,cAAA;EAEA,mBAAA;EAEA,kBAAA;AAnOF;;AAyOA;EAEE,oCAAA;AAvOF;;AA6OA;EAEE,cAAA;AA3OF;;AAiPA;;EAIE,aAAA;EAEA,uBAAA;EAEA,YAAA;EAEA,kBAAA;EAEA,oBAAA;EAEA,yBAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,cAAA;EAEA,kBAAA;AAzPF;;AA+PA;;EAIE,kBAAA;EAEA,iCAAA;EAEA,eAAA;AAhQF;;AAsQA;EAEE,aAAA;EAEA,mBAAA;EAEA,yBAAA;EAEA,YAAA;EAEA,gBAAA;EAEA,oBAAA;EAEA,qDAAA;AA1QF;;AAgRA;EAEE,8BAAA;AA9QF;;AAoRA;EAEE,aAAA;EAEA,mBAAA;EAEA,yBAAA;EAEA,eAAA;EAEA,YAAA;AAtRF;;AA4RA;EAEE,oBAAA;EAEA,mBAAA;EAEA,uBAAA;EAEA,mBAAA;EAEA,kBAAA;EAEA,kBAAA;EAEA,gBAAA;EAEA,qBAAA;AAjSF;;AAuSA;EAEE,wCAAA;EAEA,sCAAA;AAtSF;;AA4SA;EAEE,6CAAA;EAEA,2CAAA;AA3SF;;AAiTA;EAEE,wCAAA;EAEA,iCAAA;AAhTF;;AAsTA;EAEE,mBAAA;EAEA,iCAAA;AArTF;;AA2TA;EAEE,aAAA;EAEA,gDAAA;EAEA,SAAA;AA3TF;;AAiUA;EAEE,aAAA;EAEA,uBAAA;EAEA,WAAA;EAEA,WAAA;EAEA,YAAA;EAEA,eAAA;EAEA,2CAAA;EAEA,mBAAA;EAEA,gBAAA;EAEA,cAAA;EAEA,gBAAA;EAEA,gEAAA;AA1UF;;AAgVA;EAEE,qBAAA;EAEA,mBAAA;AA/UF;;AAqVA;EAEE,wCAAA;EAEA,mBAAA;EAEA,sDAAA;AArVF;;AA2VA;EAEE,mBAAA;EAEA,YAAA;AA1VF;;AAgWA;EAEE,aAAA;EAEA,cAAA;EAEA,eAAA;EAEA,iBAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,iCAAA;EAEA,kBAAA;AAtWF;;AA4WA;EAEE,mBAAA;EAEA,cAAA;AA3WF;;AAiXA;EAEE,aAAA;EAEA,cAAA;EAEA,sBAAA;EAEA,YAAA;EAEA,YAAA;AAnXF;;AAyXA;EAEE,sCAAA;EAEA,iBAAA;AAxXF;;AA8XA;EAEE,wCAAA;EAEA,iBAAA;EAEA,gBAAA;AA9XF;;AAoYA;EAEE,mBAAA;EAEA,oCAAA;EAEA,kBAAA;AApYF;;AA0YA;EAEE,iCAAA;AAxYF;;AA8YA;EAEE,kBAAA;EAEA,gBAAA;EAEA,iDAAA;EAEA,mBAAA;EAEA,mBAAA;AAhZF;;AAsZA;;EAIE,aAAA;EAEA,uBAAA;EAEA,8BAAA;EAEA,SAAA;EAEA,mBAAA;AAzZF;;AA+ZA;;EAIE,mBAAA;EAEA,sCAAA;EAEA,kBAAA;EAEA,gBAAA;AAjaF;;AAuaA;;EAIE,SAAA;EAEA,wCAAA;EAEA,iBAAA;AAxaF;;AA8aA;EAEE,qBAAA;EAEA,mBAAA;EAEA,iCAAA;AA9aF;;AAobA;EAEE,aAAA;EAEA,iBAAA;EAEA,sBAAA;EAEA,mBAAA;EAEA,uBAAA;EAEA,YAAA;EAEA,eAAA;EAEA,4BAAA;EAEA,mBAAA;EAEA,gBAAA;EAEA,kBAAA;AA5bF;;AAkcA;EAEE,mBAAA;EAEA,qBAAA;EAEA,mBAAA;AAlcF;;AAwcA;EAEE,aAAA;EAEA,aAAA;EAEA,cAAA;EAEA,sBAAA;EAEA,mBAAA;EAEA,kBAAA;EAEA,mBAAA;EAEA,iCAAA;EAEA,iBAAA;AA9cF;;AAodA;EAEE,mBAAA;EAEA,cAAA;AAndF;;AAydA;EAEE,sCAAA;EAEA,kBAAA;AAxdF;;AA8dA;EAEE,oCAAA;EAEA,iBAAA;AA7dF;;AAmeA;EAEE,eAAA;EAEA,uBAAA;AAleF;;AAweA;EAEE,mBAAA;EAEA,eAAA;AAveF;;AA6eA;EAEE,SAAA;EAEA,uBAAA;EAEA,cAAA;EAEA,iBAAA;EAEA,gBAAA;EAEA,0BAAA;AAhfF;;AAsfA;EAEE,mBAAA;AApfF;;AA0fA;EAEE,aAAA;EAEA,mBAAA;EAEA,8BAAA;EAEA,SAAA;EAEA,gBAAA;AA5fF;;AAkgBA;EAEE,aAAA;EAEA,uBAAA;EAEA,WAAA;EAEA,gBAAA;EAEA,wCAAA;EAEA,kBAAA;AArgBF;;AA2gBA;EAEE,mBAAA;EAEA,iCAAA;AA1gBF;;AAghBA;EAEE,aAAA;EAEA,uBAAA;EAEA,WAAA;EAEA,gBAAA;EAEA,qBAAA;EAEA,iDAAA;EAEA,kBAAA;EAEA,mBAAA;EAEA,wCAAA;EAEA,kBAAA;AAvhBF;;AA6hBA;EAEE,qBAAA;EAEA,mBAAA;EAEA,cAAA;AA7hBF;;AAmiBA;EAEE,qBAAA;EAEA,mBAAA;EAEA,cAAA;AAniBF;;AAyiBA;EAEE,kBAAA;AAviBF;;AA6iBA;EAEE,mBAAA;AA3iBF;;AAijBA;EAEE,qBAAA;EAEA,mBAAA;EAEA,iCAAA;AAjjBF;;AAujBA;EAEE,cAAA;EAEA,iDAAA;EAEA,mBAAA;AAvjBF;;AA6jBA;EAEE,gBAAA;EAEA,SAAA;EAEA,iBAAA;AA7jBF;;AAmkBA;EAEE,qBAAA;EAEA,8CAAA;EAEA,mBAAA;EAEA,wCAAA;EAEA,kBAAA;EAEA,gBAAA;EAEA,uBAAA;EAEA,mBAAA;AAxkBF;;AA8kBA;EAEE,qBAAA;EAEA,oDAAA;EAEA,wCAAA;EAEA,sBAAA;AA/kBF;;AAqlBA;EAEE,gBAAA;AAnlBF;;AAylBA;EAEE,mBAAA;AAvlBF;;AA6lBA;EAEE,cAAA;EAEA,sCAAA;EAEA,kBAAA;AA7lBF;;AAmmBA;EAEE,cAAA;EAEA,gBAAA;EAEA,kBAAA;EAEA,gBAAA;EAEA,oCAAA;EAEA,kBAAA;EAEA,uBAAA;EAEA,mBAAA;AAxmBF;;AA8mBA;EAEE,oBAAA;EAEA,mBAAA;EAEA,oBAAA;EAEA,mBAAA;EAEA,cAAA;EAEA,iBAAA;EAEA,gBAAA;EAEA,wBAAA;EAEA,0BAAA;AApnBF;;AA0nBA;EAEE,mBAAA;EAEA,cAAA;AAznBF;;AA+nBA;EAEE,aAAA;EAEA,iBAAA;EAEA,sBAAA;EAEA,mBAAA;EAEA,uBAAA;EAEA,WAAA;EAEA,4CAAA;EAEA,mBAAA;EAEA,oCAAA;EAEA,kBAAA;AAtoBF;;AA4oBA;EAEE,iCAAA;EAEA,iBAAA;AA3oBF;;AAipBA;EAEE,sCAAA;EAEA,kBAAA;AAhpBF;;AAspBA;EAEE,kBAAA;AAppBF;;AA0pBA;EAEE,aAAA;EAEA,gDAAA;EAEA,WAAA;AA1pBF;;AAgqBA;EAEE,aAAA;EAEA,YAAA;EAEA,sBAAA;EAEA,WAAA;EAEA,aAAA;EAEA,iDAAA;EAEA,mBAAA;EAEA,gBAAA;AArqBF;;AA2qBA;EAEE,iBAAA;AAzqBF;;AA+qBA;EAEE,oCAAA;EAEA,kBAAA;EAEA,gBAAA;AA/qBF;;AAqrBA;EAEE,uBAAA;EAEA,sCAAA;EAEA,iBAAA;EAEA,gBAAA;AAtrBF;;AA4rBA;EAEE,cAAA;AA1rBF;;AAgsBA;EAEE,4BAAA;AA9rBF;;AAosBA;EAEE,kBAAA;EAEA,mBAAA;EAEA,iCAAA;EAEA,iBAAA;EAEA,wBAAA;AAtsBF;;AA4sBA;EAEE,gBAAA;EAEA,cAAA;AA3sBF;;AAitBA;EAEE,aAAA;EAEA,mBAAA;EAEA,YAAA;EAEA,mBAAA;EAEA,sCAAA;EAEA,kBAAA;EAEA,gBAAA;AArtBF;;AA2tBA;EAEE,OAAA;EAEA,WAAA;EAEA,2CAAA;EAEA,WAAA;AA5tBF;;AAkuBA;EAEE,aAAA;EAEA,mBAAA;EAEA,WAAA;EAEA,mBAAA;EAEA,uBAAA;EAEA,iDAAA;EAEA,kBAAA;EAEA,4CAAA;EAEA,wCAAA;EAEA,iBAAA;AAzuBF;;AA+uBA;EAEE,iCAAA;EAEA,eAAA;AA9uBF;;AAovBA;EAEE,aAAA;EAEA,mBAAA;EAEA,uBAAA;EAEA,YAAA;EAEA,iBAAA;EAEA,aAAA;EAEA,wCAAA;EAEA,iBAAA;AAzvBF;;AA+vBA;EAEE,aAAA;EAEA,mBAAA;EAEA,eAAA;EAEA,YAAA;EAEA,eAAA;EAEA,wCAAA;AAlwBF;;AAwwBA;EAEE,cAAA;EAEA,iBAAA;AAvwBF;;AA6wBA;EAEE,eAAA;AA3wBF;;AAixBA;EAEE;IAEE,aAAA;EAhxBF;EAsxBA;IAEE,qCAAA;EArxBF;EA2xBA;IAEE,iBAAA;EA1xBF;EAgyBA;IAEE,oBAAA;IAEA,8BAAA;EAhyBF;EAsyBA;IAEE,WAAA;EAryBF;AACF;AA4yBA;EAEE;IAEE,sBAAA;EA5yBF;EAkzBA;IAEE,0BAAA;IAEA,SAAA;EAlzBF;EAwzBA;IAEE,aAAA;EAvzBF;EA6zBA;IAEE,0BAAA;EA5zBF;EAk0BA;IAEE,aAAA;EAj0BF;AACF;AAw0BA;EAEE;IAEE,mBAAA;IAEA,kBAAA;EAz0BF;EA+0BA;IAEE,mBAAA;IAEA,kBAAA;EA/0BF;EAq1BA;;IAIE,0BAAA;EAr1BF;EA21BA;;IAIE,iBAAA;EA31BF;EAi2BA;IAEE,aAAA;EAh2BF;EAs2BA;;IAIE,oBAAA;IAEA,sBAAA;EAv2BF;EA62BA;IAEE,yBAAA;EA52BF;EAk3BA;;IAIE,cAAA;EAl3BF;EAw3BA;;IAIE,uBAAA;EAx3BF;AACF;AA83BA,6EAAA;AACA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA53BF;;AA+3BA;EACE;IACE,gBAAA;EA53BF;AACF","sourcesContent":[":host {\n\n  display: block;\n\n}\n\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n\n\n.file-data-asset-setup {\n\n  width: 100%;\n\n  padding-top: 1.25rem;\n\n  padding-bottom: 2.5rem;\n\n}\n\n\n\n.setup-page-header {\n\n  display: flex;\n\n  align-items: flex-start;\n\n  justify-content: space-between;\n\n  gap: 1.5rem;\n\n  margin-bottom: 1.5rem;\n\n}\n\n\n\n.setup-page-header h1 {\n\n  margin: 0 0 0.45rem;\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: clamp(1.55rem, 2vw, 1.9rem);\n\n  font-weight: 700;\n\n  letter-spacing: -0.025em;\n\n}\n\n\n\n.eyebrow {\n\n  margin: 0 0 0.35rem;\n\n  color: var(--ca-primary, #0e2e80);\n\n  font-size: 0.7rem;\n\n  font-weight: 800;\n\n  letter-spacing: 0.11em;\n\n}\n\n\n\n.page-description {\n\n  max-width: 760px;\n\n  margin: 0;\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.93rem;\n\n}\n\n\n\n.source-type-chip,\n\n.format-pill,\n\n.count-pill {\n\n  display: inline-flex;\n\n  align-items: center;\n\n  gap: 0.45rem;\n\n  flex-shrink: 0;\n\n  border: 1px solid var(--ca-border-light, #e9edf3);\n\n  border-radius: 999px;\n\n  background: #fff;\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.78rem;\n\n  font-weight: 600;\n\n  padding: 0.48rem 0.8rem;\n\n}\n\n\n\n.source-type-chip i {\n\n  color: var(--ca-primary, #0e2e80);\n\n}\n\n\n\n.setup-card {\n\n  overflow: hidden;\n\n  border: 1px solid var(--ca-border-light, #e9edf3);\n\n  border-radius: 16px;\n\n  background: var(--ca-surface, #fff);\n\n  box-shadow: 0 4px 16px rgba(7, 17, 46, 0.055);\n\n}\n\n\n\n.setup-stepper {\n\n  display: grid;\n\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n\n  gap: 0;\n\n  padding: 1.25rem 1.5rem;\n\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n\n  background: #fbfcff;\n\n}\n\n\n\n.stepper-item {\n\n  position: relative;\n\n  display: flex;\n\n  align-items: center;\n\n  gap: 0.75rem;\n\n  min-width: 0;\n\n  padding-right: 1rem;\n\n}\n\n\n\n.stepper-item:not(:last-child)::after {\n\n  position: absolute;\n\n  top: 1rem;\n\n  right: 0.85rem;\n\n  left: 2.7rem;\n\n  height: 1px;\n\n  background: var(--ca-border, #dfe4ec);\n\n  content: '';\n\n  transform: translateX(1rem);\n\n}\n\n\n\n.stepper-marker {\n\n  z-index: 1;\n\n  display: grid;\n\n  width: 2rem;\n\n  height: 2rem;\n\n  flex: 0 0 2rem;\n\n  place-items: center;\n\n  border: 1px solid var(--ca-border, #dfe4ec);\n\n  border-radius: 50%;\n\n  background: #fff;\n\n  color: var(--ca-text-muted, #8c96a8);\n\n  font-size: 0.82rem;\n\n  font-weight: 700;\n\n}\n\n\n\n.stepper-item.active .stepper-marker,\n\n.stepper-item.completed .stepper-marker {\n\n  border-color: var(--ca-primary, #0e2e80);\n\n  background: var(--ca-primary, #0e2e80);\n\n  color: #fff;\n\n}\n\n\n\n.stepper-copy {\n\n  display: flex;\n\n  min-width: 0;\n\n  flex-direction: column;\n\n  gap: 0.1rem;\n\n}\n\n\n\n.stepper-title {\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.84rem;\n\n  font-weight: 700;\n\n}\n\n\n\n.stepper-description {\n\n  color: var(--ca-text-muted, #8c96a8);\n\n  font-size: 0.72rem;\n\n}\n\n\n\n.stepper-item:not(.active):not(.completed) .stepper-title {\n\n  color: var(--ca-text-muted, #8c96a8);\n\n}\n\n\n\n.wizard-panel {\n\n  padding: clamp(1.25rem, 3vw, 2rem);\n\n}\n\n\n\n.panel-heading {\n\n  display: flex;\n\n  align-items: flex-start;\n\n  gap: 0.9rem;\n\n  margin-bottom: 1.5rem;\n\n}\n\n\n\n.panel-heading-icon {\n\n  display: grid;\n\n  width: 2.75rem;\n\n  height: 2.75rem;\n\n  flex: 0 0 2.75rem;\n\n  place-items: center;\n\n  border-radius: 12px;\n\n  background: #edf3ff;\n\n  color: var(--ca-primary, #0e2e80);\n\n  font-size: 1.2rem;\n\n}\n\n\n\n.panel-heading-icon.success-icon {\n\n  background: #eaf7f0;\n\n  color: #198754;\n\n}\n\n\n\n.panel-heading h2 {\n\n  margin: 0 0 0.3rem;\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 1.18rem;\n\n  font-weight: 700;\n\n}\n\n\n\n.panel-heading p {\n\n  margin: 0;\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.88rem;\n\n}\n\n\n\n.form-grid {\n\n  display: grid;\n\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n\n  gap: 1.25rem 1.5rem;\n\n}\n\n\n\n.field-group {\n\n  min-width: 0;\n\n}\n\n\n\n.field-full {\n\n  grid-column: 1 / -1;\n\n}\n\n\n\n.form-label {\n\n  display: inline-block;\n\n  margin-bottom: 0.45rem;\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.84rem;\n\n  font-weight: 650;\n\n}\n\n\n\n.required-mark {\n\n  color: #dc3545;\n\n}\n\n\n\n.form-control,\n\n.form-select {\n\n  min-height: 2.75rem;\n\n  border-color: var(--ca-input-border, #dfe4ec);\n\n  border-radius: 8px;\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.9rem;\n\n  box-shadow: none;\n\n}\n\n\n\n.form-control:focus,\n\n.form-select:focus {\n\n  border-color: var(--ca-input-focus, #2850ad);\n\n  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.13);\n\n}\n\n\n\n.field-hint,\n\n.field-error {\n\n  display: block;\n\n  margin-top: 0.35rem;\n\n  font-size: 0.76rem;\n\n}\n\n\n\n.field-hint {\n\n  color: var(--ca-text-muted, #8c96a8);\n\n}\n\n\n\n.field-error {\n\n  color: #dc3545;\n\n}\n\n\n\n.identity-note,\n\n.summary-note {\n\n  display: flex;\n\n  align-items: flex-start;\n\n  gap: 0.65rem;\n\n  margin-top: 1.5rem;\n\n  padding: 0.9rem 1rem;\n\n  border: 1px solid #dce6ff;\n\n  border-radius: 10px;\n\n  background: #f5f8ff;\n\n  color: #435574;\n\n  font-size: 0.82rem;\n\n}\n\n\n\n.identity-note i,\n\n.summary-note i {\n\n  margin-top: 0.1rem;\n\n  color: var(--ca-primary, #0e2e80);\n\n  font-size: 1rem;\n\n}\n\n\n\n.wizard-actions {\n\n  display: flex;\n\n  align-items: center;\n\n  justify-content: flex-end;\n\n  gap: 0.75rem;\n\n  margin-top: 2rem;\n\n  padding-top: 1.25rem;\n\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n\n}\n\n\n\n.wizard-actions-between {\n\n  justify-content: space-between;\n\n}\n\n\n\n.action-group {\n\n  display: flex;\n\n  align-items: center;\n\n  justify-content: flex-end;\n\n  flex-wrap: wrap;\n\n  gap: 0.65rem;\n\n}\n\n\n\n.btn {\n\n  display: inline-flex;\n\n  align-items: center;\n\n  justify-content: center;\n\n  min-height: 2.55rem;\n\n  border-radius: 8px;\n\n  font-size: 0.84rem;\n\n  font-weight: 650;\n\n  padding: 0.55rem 1rem;\n\n}\n\n\n\n.btn-primary {\n\n  border-color: var(--ca-primary, #0e2e80);\n\n  background: var(--ca-primary, #0e2e80);\n\n}\n\n\n\n.btn-primary:hover:not(:disabled) {\n\n  border-color: var(--ca-primary-dark, #0d2863);\n\n  background: var(--ca-primary-dark, #0d2863);\n\n}\n\n\n\n.btn-outline-primary {\n\n  border-color: var(--ca-primary, #0e2e80);\n\n  color: var(--ca-primary, #0e2e80);\n\n}\n\n\n\n.btn-outline-primary:hover:not(:disabled) {\n\n  background: #edf3ff;\n\n  color: var(--ca-primary, #0e2e80);\n\n}\n\n\n\n.choice-grid {\n\n  display: grid;\n\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n\n  gap: 1rem;\n\n}\n\n\n\n.choice-card {\n\n  display: flex;\n\n  align-items: flex-start;\n\n  gap: 0.9rem;\n\n  width: 100%;\n\n  min-width: 0;\n\n  padding: 1.1rem;\n\n  border: 1px solid var(--ca-border, #dfe4ec);\n\n  border-radius: 12px;\n\n  background: #fff;\n\n  color: inherit;\n\n  text-align: left;\n\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n\n}\n\n\n\n.choice-card:hover:not(:disabled) {\n\n  border-color: #9db7f6;\n\n  background: #fbfcff;\n\n}\n\n\n\n.choice-card.selected {\n\n  border-color: var(--ca-primary, #0e2e80);\n\n  background: #f5f8ff;\n\n  box-shadow: inset 0 0 0 1px var(--ca-primary, #0e2e80);\n\n}\n\n\n\n.choice-card:disabled {\n\n  cursor: not-allowed;\n\n  opacity: 0.8;\n\n}\n\n\n\n.choice-icon {\n\n  display: grid;\n\n  width: 2.55rem;\n\n  height: 2.55rem;\n\n  flex: 0 0 2.55rem;\n\n  place-items: center;\n\n  border-radius: 10px;\n\n  background: #edf3ff;\n\n  color: var(--ca-primary, #0e2e80);\n\n  font-size: 1.12rem;\n\n}\n\n\n\n.choice-icon.secondary {\n\n  background: #f1f3f6;\n\n  color: #667085;\n\n}\n\n\n\n.choice-content {\n\n  display: flex;\n\n  flex: 1 1 auto;\n\n  flex-direction: column;\n\n  gap: 0.35rem;\n\n  min-width: 0;\n\n}\n\n\n\n.choice-content strong {\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.9rem;\n\n}\n\n\n\n.choice-content span {\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.8rem;\n\n  line-height: 1.5;\n\n}\n\n\n\n.selection-indicator {\n\n  margin-top: 0.15rem;\n\n  color: var(--ca-text-muted, #8c96a8);\n\n  font-size: 1.05rem;\n\n}\n\n\n\n.choice-card.selected .selection-indicator {\n\n  color: var(--ca-primary, #0e2e80);\n\n}\n\n\n\n.file-import-panel {\n\n  margin-top: 1.5rem;\n\n  padding: 1.25rem;\n\n  border: 1px solid var(--ca-border-light, #e9edf3);\n\n  border-radius: 12px;\n\n  background: #fcfdff;\n\n}\n\n\n\n.file-panel-heading,\n\n.table-heading {\n\n  display: flex;\n\n  align-items: flex-start;\n\n  justify-content: space-between;\n\n  gap: 1rem;\n\n  margin-bottom: 1rem;\n\n}\n\n\n\n.file-panel-heading h3,\n\n.table-heading h3 {\n\n  margin: 0 0 0.25rem;\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.98rem;\n\n  font-weight: 700;\n\n}\n\n\n\n.file-panel-heading p,\n\n.table-heading p {\n\n  margin: 0;\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.8rem;\n\n}\n\n\n\n.format-pill {\n\n  border-color: #dce6ff;\n\n  background: #f5f8ff;\n\n  color: var(--ca-primary, #0e2e80);\n\n}\n\n\n\n.file-dropzone {\n\n  display: flex;\n\n  min-height: 210px;\n\n  flex-direction: column;\n\n  align-items: center;\n\n  justify-content: center;\n\n  gap: 0.45rem;\n\n  padding: 1.5rem;\n\n  border: 1.5px dashed #b8c5dd;\n\n  border-radius: 12px;\n\n  background: #fff;\n\n  text-align: center;\n\n}\n\n\n\n.file-dropzone.has-file {\n\n  border-style: solid;\n\n  border-color: #b7e3ca;\n\n  background: #fbfefc;\n\n}\n\n\n\n.dropzone-icon {\n\n  display: grid;\n\n  width: 3.1rem;\n\n  height: 3.1rem;\n\n  margin-bottom: 0.25rem;\n\n  place-items: center;\n\n  border-radius: 50%;\n\n  background: #edf3ff;\n\n  color: var(--ca-primary, #0e2e80);\n\n  font-size: 1.4rem;\n\n}\n\n\n\n.file-selected-icon {\n\n  background: #eaf7f0;\n\n  color: #198754;\n\n}\n\n\n\n.file-dropzone > strong {\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.91rem;\n\n}\n\n\n\n.file-dropzone > span:not(.dropzone-icon) {\n\n  color: var(--ca-text-muted, #8c96a8);\n\n  font-size: 0.8rem;\n\n}\n\n\n\n.selected-file-name {\n\n  max-width: 100%;\n\n  overflow-wrap: anywhere;\n\n}\n\n\n\n.browse-button {\n\n  margin-top: 0.55rem;\n\n  cursor: pointer;\n\n}\n\n\n\n.text-button {\n\n  border: 0;\n\n  background: transparent;\n\n  color: #b42332;\n\n  font-size: 0.8rem;\n\n  font-weight: 650;\n\n  text-decoration: underline;\n\n}\n\n\n\n.file-error {\n\n  margin-top: 0.65rem;\n\n}\n\n\n\n.import-actions {\n\n  display: flex;\n\n  align-items: center;\n\n  justify-content: space-between;\n\n  gap: 1rem;\n\n  margin-top: 1rem;\n\n}\n\n\n\n.import-context {\n\n  display: flex;\n\n  align-items: flex-start;\n\n  gap: 0.5rem;\n\n  max-width: 620px;\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.78rem;\n\n}\n\n\n\n.import-context i {\n\n  margin-top: 0.05rem;\n\n  color: var(--ca-primary, #0e2e80);\n\n}\n\n\n\n.import-result {\n\n  display: flex;\n\n  align-items: flex-start;\n\n  gap: 0.6rem;\n\n  margin-top: 1rem;\n\n  padding: 0.85rem 1rem;\n\n  border: 1px solid var(--ca-border-light, #e9edf3);\n\n  border-radius: 9px;\n\n  background: #f8faff;\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.82rem;\n\n}\n\n\n\n.import-result-success {\n\n  border-color: #b7e3ca;\n\n  background: #f1fbf5;\n\n  color: #17653d;\n\n}\n\n\n\n.import-result-error {\n\n  border-color: #f3b9c0;\n\n  background: #fff5f6;\n\n  color: #a51f2d;\n\n}\n\n\n\n.imported-assets-section {\n\n  margin-top: 1.5rem;\n\n}\n\n\n\n.table-heading {\n\n  align-items: center;\n\n}\n\n\n\n.count-pill {\n\n  border-color: #dce6ff;\n\n  background: #f5f8ff;\n\n  color: var(--ca-primary, #0e2e80);\n\n}\n\n\n\n.assets-table-wrapper {\n\n  overflow: auto;\n\n  border: 1px solid var(--ca-border-light, #e9edf3);\n\n  border-radius: 10px;\n\n}\n\n\n\n.assets-table {\n\n  min-width: 780px;\n\n  margin: 0;\n\n  font-size: 0.8rem;\n\n}\n\n\n\n.assets-table thead th {\n\n  padding: 0.85rem 1rem;\n\n  border-bottom-color: var(--ca-border, #dfe4ec);\n\n  background: #f5f7fb;\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.72rem;\n\n  font-weight: 750;\n\n  letter-spacing: 0.025em;\n\n  white-space: nowrap;\n\n}\n\n\n\n.assets-table tbody td {\n\n  padding: 0.85rem 1rem;\n\n  border-bottom-color: var(--ca-border-light, #e9edf3);\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  vertical-align: middle;\n\n}\n\n\n\n.assets-table tbody tr:last-child td {\n\n  border-bottom: 0;\n\n}\n\n\n\n.assets-table tbody tr:hover {\n\n  background: #fbfcff;\n\n}\n\n\n\n.assets-table td strong {\n\n  display: block;\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.82rem;\n\n}\n\n\n\n.asset-description {\n\n  display: block;\n\n  max-width: 260px;\n\n  margin-top: 0.2rem;\n\n  overflow: hidden;\n\n  color: var(--ca-text-muted, #8c96a8);\n\n  font-size: 0.72rem;\n\n  text-overflow: ellipsis;\n\n  white-space: nowrap;\n\n}\n\n\n\n.status-pill {\n\n  display: inline-flex;\n\n  align-items: center;\n\n  border-radius: 999px;\n\n  background: #f1f3f6;\n\n  color: #667085;\n\n  font-size: 0.7rem;\n\n  font-weight: 700;\n\n  padding: 0.25rem 0.55rem;\n\n  text-transform: capitalize;\n\n}\n\n\n\n.status-pill.status-active {\n\n  background: #eaf7f0;\n\n  color: #198754;\n\n}\n\n\n\n.empty-assets-state {\n\n  display: flex;\n\n  min-height: 150px;\n\n  flex-direction: column;\n\n  align-items: center;\n\n  justify-content: center;\n\n  gap: 0.4rem;\n\n  border: 1px dashed var(--ca-border, #dfe4ec);\n\n  border-radius: 10px;\n\n  color: var(--ca-text-muted, #8c96a8);\n\n  text-align: center;\n\n}\n\n\n\n.empty-assets-state i {\n\n  color: var(--ca-primary, #0e2e80);\n\n  font-size: 1.5rem;\n\n}\n\n\n\n.empty-assets-state strong {\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.88rem;\n\n}\n\n\n\n.empty-assets-state span {\n\n  font-size: 0.78rem;\n\n}\n\n\n\n.summary-grid {\n\n  display: grid;\n\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n\n  gap: 0.9rem;\n\n}\n\n\n\n.summary-item {\n\n  display: flex;\n\n  min-width: 0;\n\n  flex-direction: column;\n\n  gap: 0.4rem;\n\n  padding: 1rem;\n\n  border: 1px solid var(--ca-border-light, #e9edf3);\n\n  border-radius: 10px;\n\n  background: #fff;\n\n}\n\n\n\n.summary-item-full {\n\n  grid-column: 1 / -1;\n\n}\n\n\n\n.summary-label {\n\n  color: var(--ca-text-muted, #8c96a8);\n\n  font-size: 0.74rem;\n\n  font-weight: 650;\n\n}\n\n\n\n.summary-item strong {\n\n  overflow-wrap: anywhere;\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.9rem;\n\n  font-weight: 700;\n\n}\n\n\n\n.summary-item .summary-success {\n\n  color: #198754;\n\n}\n\n\n\n.summary-long-value {\n\n  font-size: 0.8rem !important;\n\n}\n\n\n\n.summary-note code {\n\n  border-radius: 4px;\n\n  background: #e8eeff;\n\n  color: var(--ca-primary, #0e2e80);\n\n  font-size: 0.8rem;\n\n  padding: 0.12rem 0.28rem;\n\n}\n\n\n\n.update-panel {\n\n  max-width: 960px;\n\n  margin: 0 auto;\n\n}\n\n\n\n.section-divider-label {\n\n  display: flex;\n\n  align-items: center;\n\n  gap: 0.75rem;\n\n  margin: 0 0 1.25rem;\n\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 0.82rem;\n\n  font-weight: 700;\n\n}\n\n\n\n.section-divider-label::after {\n\n  flex: 1;\n\n  height: 1px;\n\n  background: var(--ca-border-light, #e9edf3);\n\n  content: '';\n\n}\n\n\n\n.readonly-value {\n\n  display: flex;\n\n  align-items: center;\n\n  gap: 0.6rem;\n\n  min-height: 2.75rem;\n\n  padding: 0.65rem 0.8rem;\n\n  border: 1px solid var(--ca-border-light, #e9edf3);\n\n  border-radius: 8px;\n\n  background: var(--ca-surface-muted, #f7f9fc);\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.9rem;\n\n}\n\n\n\n.readonly-value i {\n\n  color: var(--ca-primary, #0e2e80);\n\n  font-size: 1rem;\n\n}\n\n\n\n.update-loading {\n\n  display: flex;\n\n  align-items: center;\n\n  justify-content: center;\n\n  gap: 0.75rem;\n\n  min-height: 220px;\n\n  padding: 2rem;\n\n  color: var(--ca-text-secondary, #4b5870);\n\n  font-size: 0.9rem;\n\n}\n\n\n\n.update-load-error {\n\n  display: flex;\n\n  align-items: center;\n\n  flex-wrap: wrap;\n\n  gap: 0.85rem;\n\n  padding: 1.5rem;\n\n  color: var(--ca-text-secondary, #4b5870);\n\n}\n\n\n\n.update-load-error > i {\n\n  color: #dc3545;\n\n  font-size: 1.2rem;\n\n}\n\n\n\n.update-load-error > span {\n\n  flex: 1 1 220px;\n\n}\n\n\n\n@media (max-width: 640px) {\n\n  .update-panel {\n\n    padding: 1rem;\n\n  }\n\n\n\n  .update-panel .form-grid {\n\n    grid-template-columns: minmax(0, 1fr);\n\n  }\n\n\n\n  .update-panel .field-full {\n\n    grid-column: auto;\n\n  }\n\n\n\n  .update-panel .wizard-actions {\n\n    align-items: stretch;\n\n    flex-direction: column-reverse;\n\n  }\n\n\n\n  .update-panel .wizard-actions .btn {\n\n    width: 100%;\n\n  }\n\n}\n\n\n\n@media (max-width: 850px) {\n\n  .setup-page-header {\n\n    flex-direction: column;\n\n  }\n\n\n\n  .setup-stepper {\n\n    grid-template-columns: 1fr;\n\n    gap: 1rem;\n\n  }\n\n\n\n  .stepper-item:not(:last-child)::after {\n\n    display: none;\n\n  }\n\n\n\n  .choice-grid {\n\n    grid-template-columns: 1fr;\n\n  }\n\n\n\n  .stepper-description {\n\n    display: none;\n\n  }\n\n}\n\n\n\n@media (max-width: 600px) {\n\n  .file-setup-breadcrumb {\n\n    padding-right: 1rem;\n\n    padding-left: 1rem;\n\n  }\n\n\n\n  .file-data-asset-setup {\n\n    padding-right: 1rem;\n\n    padding-left: 1rem;\n\n  }\n\n\n\n  .form-grid,\n\n  .summary-grid {\n\n    grid-template-columns: 1fr;\n\n  }\n\n\n\n  .field-full,\n\n  .summary-item-full {\n\n    grid-column: auto;\n\n  }\n\n\n\n  .wizard-panel {\n\n    padding: 1rem;\n\n  }\n\n\n\n  .import-actions,\n\n  .wizard-actions-between {\n\n    align-items: stretch;\n\n    flex-direction: column;\n\n  }\n\n\n\n  .action-group {\n\n    justify-content: flex-end;\n\n  }\n\n\n\n  .wizard-actions > .btn,\n\n  .action-group .btn {\n\n    flex: 1 1 auto;\n\n  }\n\n\n\n  .file-panel-heading,\n\n  .table-heading {\n\n    align-items: flex-start;\n\n  }\n\n}\n\n\n/* Keeps Purview qualified names readable in the staged data-asset preview. */\n.qualified-name {\n  display: inline-block;\n  max-width: 22rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n@media (max-width: 767.98px) {\n  .qualified-name {\n    max-width: 12rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
